export class CounselingRequest{
    public counselingName: string;
    public observation: string;
    public idCounselingType: number;
}